import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqData } from '@/mocks/faq';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Najczęściej zadawane pytania
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            Znajdź odpowiedzi na najczęstsze pytania dotyczące Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-50/50 transition-colors duration-200"
              >
                <h3 className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div
                  className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </div>
              </button>

              {openIndex === index && (
                <div className="px-5 pb-5 animate-[fadeIn_0.3s_ease-out]">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500 mb-3">
            Masz więcej pytań? Sprawdź nasz szczegółowy przewodnik.
          </p>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-200 whitespace-nowrap"
          >
            Kompletny przewodnik Kakobuy
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}